import type { MessageBundle, MessageCatalog } from '@event/i18n';
import csCommon from '@event/i18n/resources/cs/common.json';
import enCommon from '@event/i18n/resources/en/common.json';
import { professionalCs, professionalEn } from './professional-copy';
import { privacyCs, privacyEn } from './privacy-copy';
import { publicAnalyticsCs, publicAnalyticsEn } from './public-analytics-copy';
import { brandingCs, brandingEn } from './branding-copy';
import { helpCs, helpEn } from './help-copy';
import { workspaceTemplateCs, workspaceTemplateEn } from './workspace-template-copy';

/**
 * The web app ships the bootstrap bundles inline — they are tiny and being
 * tree-shakable through Vite keeps startup synchronous. Future, larger
 * surfaces can switch to lazy imports keyed by route.
 */
export const BOOTSTRAP_CATALOG: MessageCatalog = {
  cs: { ...(csCommon as MessageBundle), ...professionalCs, ...privacyCs, ...brandingCs, ...publicAnalyticsCs, ...helpCs, ...workspaceTemplateCs },
  en: { ...(enCommon as MessageBundle), ...professionalEn, ...privacyEn, ...brandingEn, ...publicAnalyticsEn, ...helpEn, ...workspaceTemplateEn },
};
